import Icon from "components/Icon";
import React from "react";
import media from "assets/images/women.jpeg";
import formatTime from "utils/formatTime";

function splitTextToLines(text) {
	let lines = [];
	let line = '';
  
	// Split the text into words
	let words = text.split(' ');
  
	for (let i = 0; i < words.length; i++) {
	  // If adding the next word would exceed the 25 character limit, start a new line
	  if (line.length + words[i].length > 25) {
		lines.push(line.trim());
		line = '';
	  }
  
	  // Add the word to the current line
	  line += words[i] + ' ';
	}
  
	// Add any remaining text as the last line
	if (line.length > 0) {
	  lines.push(line.trim());
	}
  
	// Join the lines into a single string with new line characters
	return lines.join('\n');
  }

const Convo = ({ lastMsgRef, messages: allMessages }) => {
	console.log('CONVO All Messages', allMessages)
	const dates = Object.keys(allMessages);


	const messageStatus = (value) => {
		switch(value) {
		  case 'sent':
			return 'singleTick';
		case 'delivered':
			return 'doubleTick';
		case 'read':
			return 'doubleTick';
		  default:
			return 'undelivered';
		}
	  }

	return dates.map((date, dateIndex) => {
		const messages = allMessages[date];
		return (
			<div key={dateIndex}>
				<div className="chat__date-wrapper">
					<span className="chat__date"> {date}</span>
				</div>
				{dateIndex === 0 && (
					<p className="chat__encryption-msg">
						<Icon id="lock" className="chat__encryption-icon" />
						Messages are end-to-end encrypted. No one outside of this chat, not
						even WhatsApp, can read or listen to them. Click to learn more.
					</p>
				)}
				<div className="chat__msg-group">
					{messages.map((message, msgIndex) => {
						const assignRef = () =>
							dateIndex === dates.length - 1 && msgIndex === messages.length - 1
								? lastMsgRef
								: undefined;
						return (
							<>
								{message.file ? (
									<div
										className={`chat__msg chat__img-wrapper ${
											message.direction === 0? "chat__msg--rxd" : "chat__msg--sent"
										}`}
										ref={assignRef()}
									>
										<img src={message.file} alt="" className="chat__img" />
										<span className="chat__msg-footer">
											<span>{formatTime(message.createdAt)}</span>
											{!message.direction && (
												<Icon
													id={
														// message.status === "sent"
														// 	? "singleTick"
														// 	: "doubleTick"

														messageStatus(message.status)
													}
													aria-label={message?.status}
													className={`chat__msg-status-icon ${
														message?.status === "read"
															? "chat__msg-status-icon--blue"
															: ""
													}`}
												/>
											)}
										</span>

										<button
											aria-label="Message options"
											className="chat__msg-options"
										>
											<Icon id="downArrow" className="chat__msg-options-icon" />
										</button>
									</div>
								) : message.direction === 0 ? (
									<p  className="chat__msg chat__msg--rxd" ref={assignRef()}>
										<span >{splitTextToLines(message.body)}</span>
									
										<span className="chat__msg-filler"> </span>
										<span className="chat__msg-footer">
											{formatTime(message.createdAt)}
										</span>
										<button
											aria-label="Message options"
											className="chat__msg-options"
										>
											<Icon id="downArrow" className="chat__msg-options-icon" />
										</button>
									</p>
								) : (
									<p  className="chat__msg chat__msg--sent" ref={assignRef()}>
										<span >{message.body}</span>
										<span className="chat__msg-filler"> </span>
										<span className="chat__msg-footer">
											<span> {formatTime(message.createdAt)} </span>
											<Icon
												id={
													// message?.status === "sent"
													// 	? "singleTick"
													// 	: "doubleTick"
													messageStatus(message.status)
												}
												aria-label={message?.status}
												className={`chat__msg-status-icon ${
													message?.status === "read"
														? "chat__msg-status-icon--blue"
														: ""
												}`}
											/>
										</span>
										<button
											aria-label="Message options"
											className="chat__msg-options"
										>
											<Icon id="downArrow" className="chat__msg-options-icon" />
										</button>
									</p>
								)}
							</>
						);
					})}
				</div>
			</div>
		);
	});
};

export default Convo;